/**
 * Central client-side access point for all feature repositories.
 * Components should reach data access through this rather than calling
 * individual repository composables directly.
 */
export const useRepositories = () => ({
  leadApplication: useLeadApplicationRepository(),
  influencerApplication: useInfluencerApplicationRepository(),
  leadApplicationSubmission: useLeadApplicationSubmissionRepository(),
  baseData: useBaseDataRepository(),
})
